export const roundDownToNearestHundred = (value: string | number): string => {
  const number = typeof value === 'string' ? parseInt(value, 10) : value
  const rounded = Math.floor(number / 100) * 100
  return rounded.toLocaleString('en')
}
